import styled from 'styled-components'

import { Card, Flex, Text, getPaletteColor } from 'pcln-design-system'

import { TierBadge } from '../tiers'
import { VipIncludedMaterial } from '../svgr/icons'

export const BenefitsCard = styled(Card).attrs(() => ({
  mb: [-4, null, null, null, -5],
}))`
  position: relative;
  top: -64px;
  overflow: hidden;
  border: 0;

  ${({ theme }) => theme.mediaQueries.xl} {
    top: -112px;
    border: 1px solid ${getPaletteColor('border.lightest')};
  }
`

export const Table = styled.table`
  margin: 0 -1px;
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;

  thead {
    text-align: left;

    tr th:first-of-type {
      width: 16%;
    }

    th hr {
      border: 0;
      border-top: 1px solid ${getPaletteColor('border.base')};
      margin: 0 -4px 0;
    }
  }

  tbody > tr {
    border: 0;
    margin-left: 1px;

    th {
      padding: 16px;
    }

    &:nth-of-type(even) {
      background: ${getPaletteColor('background.lightest')};

      th,
      td:not(:last-of-type) {
        border-right: 2px solid ${getPaletteColor('background.light')};
      }
    }

    &:nth-of-type(odd) {
      background: ${getPaletteColor('background.light')};

      th,
      td:not(:last-of-type) {
        border-right: 1px solid ${getPaletteColor('background.lightest')};
      }
    }
  }
`

export const BenefitRowLabel = styled.th`
  width: 16%;
`
export const BenefitRowLabelContent = styled(Text).attrs((props) => ({
  p: [1, null, null, 2],
  textStyle: 'display2',
  fontSize: [0, 0, 1],
  textAlign: 'right',
  color: 'text.light',
  ...(props.hasLabelLink && { mt: [2, 3] }),
}))``

export const BenefitsTableTierBadge = styled(TierBadge)`
  display: inline-flex;
  height: 64px;

  ${({ theme }) => theme.mediaQueries.xxl} {
    height: 72px;
  }
`

export const TierLabel = styled(Text).attrs(() => ({
  p: [null, null, null, null, 2],
  pl: [null, null, null, null, 3],
  fontSize: ['11px', null, 0],
  fontWeight: 'normal',
  lineHeight: '16px',
  color: 'text.light',
  height: ['auto', null, null, null, '64px'],
}))`
  display: table-cell;
  vertical-align: middle;
`

export const Td = styled.td`
  width: 21%;
  min-height: 72px;
  padding: 8px 16px;
`
export const TdContent = styled(Text).attrs(() => ({
  ml: 3,
  textStyle: 'display1',
  color: 'primary.dark',
}))``

export const VipIncludedMaterialResponsive = styled(VipIncludedMaterial)`
  font-size: 24px;
  line-height: 24px;
  height: 24px;

  ${({ theme }) => theme.mediaQueries.xxl} {
    font-size: 32px;
    line-height: 32px;
    height: 32px;
  }
`

/* Mobile Tabs */
export const MobileTabWrapper = styled(Flex).attrs(() => ({ width: 1 }))`
  border-radius: 6px 6px 0 0;
  border-bottom: 1px solid ${getPaletteColor('border.base')};
  overflow: hidden;
`
export const MobileTabContent = styled(Flex).attrs(() => ({
  justifyContent: 'center',
  alignItems: 'center',
  py: 3,
}))`
  flex: 1;
  flex-direction: column;
`
